module.exports = __webpack_public_path__ + "img/R6__1230.8b65bca2.jpeg";